export default __webpack_public_path__ + "static/media/Ameesh.2bc5228e.jpg";